import React from 'react';
import Img from './Img';

const TYPES = {
  cake:    { label:'1Kg Cakes',   sub:'Celebration cakes, hand-piped & personalised',          img:'IMG_0442', from:3100 },
  cupcake: { label:'Cupcakes',    sub:'Boxes of 6: flowers, bows or your favourite character', img:'IMG_0594', from:1000 },
  bento:   { label:'Bento Sets',  sub:'A 500g cake + 5 cuppies, the perfect little gift',       img:'IMG_8843', from:2600 },
};

function ksh(n) { return 'Ksh ' + n.toLocaleString('en-US'); }

export default function Bake({ setMenuType }) {
  function handleJump(type) {
    setMenuType(type);
    setTimeout(() => document.getElementById('menu')?.scrollIntoView({ behavior:'smooth' }), 50);
  }

  return (
    <section id="bake" style={{ padding:'86px 0' }}>
      <div style={{ maxWidth:1180, margin:'0 auto', padding:'0 26px' }}>
        <div style={{ textAlign:'center', maxWidth:620, margin:'0 auto 44px' }}>
          <span style={{ fontFamily:'var(--sans)', fontWeight:700, fontSize:12, letterSpacing:2.6, textTransform:'uppercase', color:'var(--plum)', display:'inline-flex', alignItems:'center', justifyContent:'center', gap:9 }}>
            What we bake
          </span>
          <h2 style={{ fontSize:'clamp(2.3rem,4.4vw,3.4rem)', margin:'12px 0 12px' }}>Three ways to celebrate</h2>
          <p style={{ color:'var(--ink-2)', fontSize:18, margin:0 }}>Same hand-piped love, three sizes of occasion.</p>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:24 }} className="kt-lines">
          {Object.entries(TYPES).map(([key, v]) => (
            <div key={key}
              style={{ background:'var(--cream)', border:'1px solid var(--line)', borderRadius:20, overflow:'hidden', boxShadow:'var(--shadow-sm)', transition:'transform .2s, box-shadow .2s' }}
              onMouseOver={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow='var(--shadow)'; }}
              onMouseOut={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow='var(--shadow-sm)'; }}>
              <div style={{ aspectRatio:'5/4', overflow:'hidden', background:'var(--blush-deep)' }}>
                <Img src={`/assets/cakes/${v.img}.jpeg`} alt={v.label}
                  style={{ width:'100%', height:'100%', objectFit:'cover' }} />
              </div>
              <div style={{ padding:'20px 22px 24px' }}>
                <h3 style={{ fontSize:28, marginBottom:4 }}>{v.label}</h3>
                <div style={{ color:'var(--ink-2)', fontSize:15, minHeight:44 }}>{v.sub}</div>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:14 }}>
                  <div style={{ fontSize:13, color:'var(--ink-3)' }}>
                    from <strong style={{ fontFamily:'var(--serif)', fontSize:22, color:'var(--plum-deep)', fontWeight:700 }}>{ksh(v.from)}</strong>
                  </div>
                  <button onClick={() => handleJump(key)}
                    style={{ fontWeight:700, fontSize:14, color:'var(--plum)', background:'none', border:'none', cursor:'pointer', padding:0 }}>
                    See flavours →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style>{`@media(max-width:860px){.kt-lines{grid-template-columns:1fr!important;max-width:420px;margin:0 auto;}}`}</style>
    </section>
  );
}
